const baseUrl = "https://youtube-v31.p.rapidapi.com"

// Require this to access the api
const headers = {
    headers: {
        'X-RapidAPI-Key': 'b51d086105msh50ca0aa73611a01p10c4b8jsn910a1ef00f1f',
        'X-RapidAPI-Host': 'youtube-v31.p.rapidapi.com'
    },
    params: {
        
        regionCode: 'US',
        order: 'date'
    }
}

export const fetchAPI = async (url) => {
   try {
    const response = await fetch(`${baseUrl}/${url}`, headers);

    const data = await response.json();

    return data;
   }
   catch (e) {
    console.log(e)
   }
}



